var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTopDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01275 0.835985C9.29042 0.835442 9.55951 0.932266 9.77332 1.10965L16.9037 7.05896C17.1464 7.26092 17.299 7.55115 17.328 7.86578C17.357 8.18041 17.2599 8.49367 17.0582 8.73666C16.8565 8.97965 16.5666 9.13246 16.2524 9.16147C15.9381 9.19048 15.6252 9.09331 15.3826 8.89135L9.01275 3.56077L2.64294 8.70097C2.52138 8.7998 2.38151 8.87361 2.23137 8.91815C2.08123 8.96269 1.92378 8.97708 1.76807 8.9605C1.61235 8.94391 1.46145 8.89668 1.32403 8.82151C1.1866 8.74634 1.06537 8.64472 0.967304 8.52249C0.858471 8.40015 0.776045 8.25662 0.725189 8.1009C0.674335 7.94517 0.656149 7.78062 0.671768 7.61753C0.687387 7.45444 0.736475 7.29634 0.815958 7.15314C0.895443 7.00993 1.00361 6.8847 1.13368 6.78529L8.26406 1.03826C8.48401 0.888915 8.74761 0.817696 9.01275 0.835985Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopDashboard);
export default __webpack_public_path__ + "static/media/arrow-top-dashboard.06078def26e523bca96a65a601ecc8e6.svg";
export { ForwardRef as ReactComponent };